class MobileNav extends HTMLElement {
    constructor() {
        super();

        this.querySelector(".mobile-nav__close").addEventListener("click", () => this.toggle());
        document.querySelector("[data-drawer-trigger='menu-drawer']").addEventListener("click", () => this.toggle());

        this.querySelectorAll("button[data-nav-parent]").forEach(parent => {
            parent.addEventListener("click", () => {
                const dataMenu = parent.getAttribute("data-menu");
                this.toggleParent(dataMenu);
            });
        });

        this.querySelectorAll(".mobile-nav__link--back-button").forEach(backButton => {
            backButton.addEventListener("click", () => {
                const dataMenu = backButton.getAttribute("data-nav-back");
                this.toggleParent(dataMenu);
            })
        });
    }

    toggle() {
        this.classList.toggle("is-active");
    }

    toggleParent(dataMenu) {
        const parent = this.querySelector(`div[data-parent='${ dataMenu }']`);
        parent.classList.toggle("is-active");
        this.querySelector(".mobile-nav__megamenu[data-nav-wrapper]").classList.toggle("is-active");
    }
}

customElements.define("mobile-nav", MobileNav);